import { Modal, Text, Stack, Flex, Button, Divider } from '@mantine/core';

interface JobFarAwayModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

/**
 * Modal warning the user that the job is far from their location (>100 miles)
 * User can choose to proceed anyway or cancel
 */
function JobFarAwayModal({
  opened,
  onClose,
  onConfirm,
  isLoading = false,
}: JobFarAwayModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      withCloseButton
      title={
        <Text fw={700} size="xl">
          Heads Up!
        </Text>
      }
    >
      <Stack gap="md" align="center" ta="center">
        <Text>
          Looks like this job is over 100 miles away, are you sure you can make
          it?
        </Text>

        <Divider w="100%" />

        <Flex justify="center" gap="sm">
          <Button
            variant="filled"
            onClick={onConfirm}
            loading={isLoading}
            size="sm"
          >
            Yes
          </Button>
          <Button
            variant="default"
            onClick={onClose}
            disabled={isLoading}
            size="sm"
          >
            No
          </Button>
        </Flex>
      </Stack>
    </Modal>
  );
}

export default JobFarAwayModal;
